import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getTemperatureAndHumidity = async (projectId, deviceId) => {
  const apiPath = `projects/${projectId}/renolog/devices/${deviceId}/temperature-and-humidity`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
  });
  const response = await axios(signedRequest);
  return response.data;
};
